import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=33a7d382&scoped=true&"
import script from "./Logout.vue?vue&type=script&setup=true&lang=js&"
export * from "./Logout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a7d382",
  null
  
)

export default component.exports